var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_46417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.681 0L0.816406 6.35878L10.681 12.7177L20.5471 6.35878L10.681 0ZM30.4124 0L20.5471 6.3594L30.4124 12.7188L40.2779 6.3594L30.4124 0ZM0.816406 19.0776L10.681 25.4365L20.5471 19.0776L10.681 12.7188L0.816406 19.0776ZM30.4124 12.7188L20.5471 19.0782L30.4124 25.4375L40.2777 19.0782L30.4124 12.7188ZM10.6817 27.5698L20.5478 33.9287L30.4124 27.5698L20.5478 21.211L10.6817 27.5698Z",
    fill: "#0061FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_46417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.4613,
    height: 34,
    fill: "white",
    transform: "translate(0.816406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosDropbox);
export default __webpack_public_path__ + "static/media/logos_dropbox.19ca6f73c14dad8abdf2f66846def29a.svg";
export { ForwardRef as ReactComponent };